import { render, staticRenderFns } from "./title_suggestions_item.vue?vue&type=template&id=1705e171"
import script from "./title_suggestions_item.vue?vue&type=script&lang=js"
export * from "./title_suggestions_item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports